import React from 'react';
import { CalendarDaysIcon, DiscAlbumIcon, Lightbulb as LightbulbIcon } from 'lucide-react';
import { PILLARS } from '../../data/site';
import { Reveal } from '../Reveal';
const ICONS = {
  events: CalendarDaysIcon,
  records: DiscAlbumIcon,
  stage: LightbulbIcon
};

// Each tile links to its section on the page.
const HREFS = {
  events: '#events',
  records: '#records',
  stage: '#stage'
};
export function Pillars() {
  return <section aria-labelledby="pillars-heading" className="relative mx-auto w-full max-w-7xl px-5 py-20 sm:px-8 sm:py-28" data-id="element-230" data-mp="3auvgkxg0eg0s">
      <h2 id="pillars-heading" className="sr-only" data-id="element-231" data-mp="35to9z1plrmvp">
        What Future Astronaut does
      </h2>
      <div className="grid gap-5 md:grid-cols-3" data-id="element-232" data-mp="3km89zthghe8x">
        {PILLARS.map((pillar, i) => {
        const Icon = ICONS[pillar.icon];
        return <Reveal key={pillar.title} delay={i * 0.08} className="h-full" data-id="element-233" data-mp="2s32px9oex6w8" data-mpi={i}>
              <a href={HREFS[pillar.icon]} className="glass group relative flex h-full flex-col overflow-hidden rounded-2xl p-7 text-inherit no-underline transition-[transform,border-color,box-shadow] duration-300 ease-expo hover:-translate-y-1.5 hover:border-violet/50 hover:shadow-neon active:scale-[0.98]" data-id="element-234" data-mp="2n5jba8nsys3r">
                <div aria-hidden="true" className="pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full opacity-0 transition-opacity duration-300 ease-out group-hover:opacity-100" style={{
              background: 'radial-gradient(circle, rgba(139,92,255,0.35) 0%, rgba(4,3,12,0) 70%)'
            }} data-id="element-235" data-mp="kh3m78g8qimw" />
                <span className="flex h-12 w-12 items-center justify-center rounded-xl border border-violet/35 bg-violet/10 text-violet-soft transition-transform duration-300 ease-expo group-hover:scale-110" data-id="element-236" data-mp="6ncem5m2l8tt">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-237" data-mp="1i29eybnpfkgh" />
                </span>
                <h3 className="mt-6 font-display text-sm tracking-[0.14em] text-white sm:text-base" data-id="element-238" data-mp="sedfa8wwcuuo">
                  {pillar.title.toUpperCase()}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-white/55" data-id="element-239" data-mp="nhn1xtch8dcy">{pillar.description}</p>
                <span className="mt-auto pt-6 font-tech text-[0.65rem] tracking-[0.3em] text-cyan/70" data-id="element-240" data-mp="12aqka2xw6v4q">
                  0{i + 1}
                </span>
              </a>
            </Reveal>;
      })}
      </div>
    </section>;
}